import React from 'react';
import { PreplannedLoad } from '../api/model/PreplannedLoad';

type PrePlannedEntryProps = {
  load: PreplannedLoad & {
    poNumber?: string;
    pickupNumber?: string;
    pickupStartDate?: string | number;
    pickupEndDate?: string | number;
    deliveryStartDate?: string | number;
    deliveryEndDate?: string | number;
  };
};

function placeLine(city?: string, state?: string, zip?: string): string {
  const cityState = [city, state].filter(Boolean).join(', ');
  return [cityState, zip].filter(Boolean).join(' ') || '—';
}

function PrePlannedEntry({ load }: PrePlannedEntryProps) {
  const origin = placeLine(load.shipperCity, load.shipperState);
  const destination = placeLine(load.consigneeCity, load.consigneeState);

  return (
    <div className="preplan-card">
      <div className="preplan-card__top">
        <div className="preplan-card__number">#{load.orderNumber}</div>
        <div className="preplan-card__route home-display">
          {origin} → {destination}
        </div>
        <div className="preplan-card__ids">
          Unit {load.unitNumber || '—'}
          {load.blNumber ? ` · BOL ${load.blNumber}` : ''}
        </div>
      </div>

      <div className="preplan-card__section">
        <div className="preplan-card__section-head">
          <div className="load-detail-badge load-detail-badge--load">L</div>
          <div className="preplan-card__section-title">Load At</div>
        </div>
        <div className="preplan-card__window">
          {load.pickupStartDate} {load.pickupStartTime} – {load.pickupEndDate} {load.pickupEndTime}
        </div>
        <div className="preplan-card__address">
          {load.shipperAddress1 ? <div>{load.shipperAddress1}</div> : null}
          {load.shipperAddress2 ? <div>{load.shipperAddress2}</div> : null}
          <div>{placeLine(load.shipperCity, load.shipperState, load.shipperZip)}</div>
        </div>
        <div className="load-detail-grid">
          <div className="load-detail-grid__cell">
            <span className="load-detail-grid__label">PO</span>
            <span className="load-detail-grid__value">{load.poNumber || '—'}</span>
          </div>
          <div className="load-detail-grid__cell">
            <span className="load-detail-grid__label">Pickup</span>
            <span className="load-detail-grid__value">{load.pickupNumber || '—'}</span>
          </div>
          <div className="load-detail-grid__cell load-detail-grid__cell--span2">
            <span className="load-detail-grid__label">Order</span>
            <span className="load-detail-grid__value">{load.orderNumber || '—'}</span>
          </div>
        </div>
      </div>

      <div className="preplan-card__section">
        <div className="preplan-card__section-head">
          <div className="load-detail-badge load-detail-badge--consignee">C</div>
          <div className="preplan-card__section-title">Consignee</div>
        </div>
        <div className="preplan-card__window">
          {load.deliveryStartDate} {load.deliveryStartTime} – {load.deliveryEndDate}{' '}
          {load.deliveryEndTime}
        </div>
        <div className="preplan-card__address">
          {load.consigneeAddress1 ? <div>{load.consigneeAddress1}</div> : null}
          {load.consigneeAddress2 ? <div>{load.consigneeAddress2}</div> : null}
          <div>{placeLine(load.consigneeCity, load.consigneeState, load.consigneeZip)}</div>
        </div>
      </div>
    </div>
  );
}

export default PrePlannedEntry;
